import type { Component } from "vue";

import type { WidgetStep } from "@/shared/model";

import { ChooseDevicePage } from "@/pages/choose-device/ui";
import { HowYouRateDevicePage } from "@/pages/how-you-rate-device/ui";
import { LeaveContactsPage } from "@/pages/leave-contacts/ui";
import { ThanksForOrderPage } from "@/pages/thanks-for-order/ui";
import { UploadDevicesListPage } from "@/pages/upload-devices-list/ui";

/** Экран, который показывается на каждом шаге виджета */
export const componentsBySteps: Record<WidgetStep, Component> = {
    chooseDevice: ChooseDevicePage,
    howYouRateDevice: HowYouRateDevicePage,
    leaveContacts: LeaveContactsPage,
    uploadDevicesList: UploadDevicesListPage,
    thanksForOrder: ThanksForOrderPage,
};
